import { useTranslation } from 'react-i18next';
import { useLocation, useMatch } from 'react-router';

import { Stepper } from '~/components';
import { bypassBlocker } from '~/constants/router';
import { routes } from '~/providers/RouterProvider/router.routes';

/** Organisation flow only — a private client is a single step. */
export const WizardSteps = () => {
  const isContactStep = !!useMatch(routes.createClientContactStep);
  const { search } = useLocation();

  const { t } = useTranslation(['clients']);

  return (
    <Stepper.Root aria-label={t('clients:create.title')} currentStep={isContactStep ? 2 : 1}>
      <Stepper.Item state={bypassBlocker} step={1} to={{ pathname: routes.createClientOrganisationStep, search }}>
        {t('clients:create.type.organisation')}
      </Stepper.Item>

      <Stepper.Item step={2} to={{ pathname: routes.createClientContactStep, search }}>
        {t('clients:create.type.contact')}
      </Stepper.Item>
    </Stepper.Root>
  );
};
